import { RgAggregatorVersion } from "./index193.js";
import { RgCoreVersion } from "@project-rouge/rg-core";
import { RgThreeVersion } from "@project-rouge/rg-three";
const getRgVersions = () => ({
	core: RgCoreVersion,
	three: RgThreeVersion,
	aggregator: RgAggregatorVersion
});
export { getRgVersions };

//# sourceMappingURL=index194.js.map